"use client";

import { Poppins, Playfair_Display } from "next/font/google";
import { createTheme } from "@mui/material/styles";

const poppins = Poppins({
  subsets: ["latin", "latin-ext"],
  weight: ["300", "400", "500", "600", "700"],
  display: "optional",
});

const playfair = Playfair_Display({
  subsets: ["latin", "latin-ext"],
  weight: ["400", "500", "600", "700"],
  display: "optional",
});

const baseTheme = createTheme();

export const theme = createTheme({
  ...baseTheme,
  cssVariables: true,
  palette: {
    primary: {
      main: "#582308", // Main brown tone,
      dark: "#434b4b", // Dark gray
    },
    secondary: {
      main: "#934713", // Warm brown
      dark: "#636363", // Darker gray
    },
    warning: {
      main: "#fecf67", // Light yellow
    },
    info: {
      main: "#2c8ffa", // Vibrant blue
    },
    background: {
      default: "#f1f1f1", // Light gray
      paper: "#f5f6f6", // Default paper bg
    },
    text: {
      primary: "#0d203b", // Dark blue for headings
      secondary: "#471800", // Deep brown
      disabled: "#d9d9d9", // Light gray for disabled text
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#eeeeee",
      300: "#e0e0e0",
      400: "#bdbdbd",
      500: "#9e9e9e",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121",
    },
  },
  typography: {
    fontFamily: poppins.style.fontFamily,
    allVariants: {
      letterSpacing: 0.2,
      color: "#231F20", // Default text color
      lineHeight: 1.6,
    },
    h1: {
      fontFamily: playfair.style.fontFamily,
      fontSize: "64px",
      fontWeight: 700,
      letterSpacing: 1.4,
      [baseTheme.breakpoints.down("md")]: {
        fontSize: "42px !important",
      },
      [baseTheme.breakpoints.down("sm")]: {
        fontSize: "36px !important",
      },
    },
    h2: {
      fontFamily: playfair.style.fontFamily,
      fontSize: "48px",
      fontWeight: 600,
      letterSpacing: 1.4,
      [baseTheme.breakpoints.down("md")]: {
        fontSize: "36px !important",
      },
      [baseTheme.breakpoints.down("sm")]: {
        fontSize: "32px !important",
      },
    },
    h3: { fontFamily: playfair.style.fontFamily },
    h4: { fontFamily: playfair.style.fontFamily },
    h5: { fontFamily: playfair.style.fontFamily },
    h6: { fontFamily: playfair.style.fontFamily },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: "#582308",
          "&:hover": {
            backgroundColor: "#461c06",
          },
          "&:active": {
            backgroundColor: "#581c08",
          },
        },
        text: {
          textTransform: "none",
          color: "#231F20",
          transition: "color 0.3s ease",
          "&:hover": {
            color: "#582308",
            backgroundColor: "transparent",
          },
          "&:active": {
            color: "#934713",
            backgroundColor: "transparent",
          },
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});
